import React from 'react';
import { AlertCircle } from 'lucide-react';

export const TOTAL_STEPS = 6;

export const COLOR = {
  navy: '#0A1F2E',
  navyMuted: '#5A6B73',
  canvas: '#F9F6EF',
  card: '#FFFFFF',
  border: '#EFE6CF',
  pacific: '#1A5C6E',
  teal: '#2CA8A0',
  gold: '#E8A830',
  error: '#dc2626',
};

export const slug = (s) =>
  String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const inputCls = (hasError) =>
  'w-full px-4 py-3 text-sm border rounded-lg focus:outline-none focus:border-[#2CA8A0] transition bg-white' +
  (hasError ? ' border-[#dc2626]' : ' border-[#EFE6CF]');

export const ProgressBar = ({ step }) => (
  <div className="mb-6" data-testid="onboarding-progress">
    <div className="flex items-center justify-between mb-2">
      <span
        className="font-mono uppercase text-[10px] tracking-[0.18em] text-[#5A6B73]"
        data-testid="onboarding-step-label"
      >
        Step {step} of {TOTAL_STEPS}
      </span>
      <span className="font-mono uppercase text-[10px] tracking-[0.18em] text-[#5A6B73]">
        {Math.round((step / TOTAL_STEPS) * 100)}%
      </span>
    </div>
    <div className="h-1.5 rounded-full bg-[#EFE6CF] overflow-hidden">
      <div
        className="h-full bg-[#E8A830] transition-all duration-300"
        style={{ width: `${(step / TOTAL_STEPS) * 100}%` }}
      />
    </div>
  </div>
);

export const Field = ({ label, error, children, testId, optional }) => (
  <div data-testid={testId}>
    <label className="block text-sm font-medium mb-2 text-[#0A1F2E]">
      {label}{' '}
      {optional && (
        <span className="text-xs font-normal text-[#5A6B73]">(optional)</span>
      )}
    </label>
    {children}
    {error && (
      <p className="mt-1 text-xs flex items-center gap-1 text-[#dc2626]">
        <AlertCircle className="w-3 h-3" /> {error}
      </p>
    )}
  </div>
);

export const Pill = ({ active, onClick, children, testId, small = false }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    aria-pressed={active}
    className={`text-left rounded-lg border transition-all font-body ${
      small ? 'px-3 py-2 text-xs' : 'px-4 py-3 text-sm'
    } ${
      active
        ? 'border-[#E8A830] bg-[#E8A830]/10 text-[#0A1F2E] font-medium'
        : 'border-[#EFE6CF] text-[#0A1F2E]/75 hover:border-[#2CA8A0]/50 hover:text-[#0A1F2E] bg-white'
    }`}
  >
    {children}
  </button>
);
